"use client"
import { useRef, useState, useEffect, useCallback } from "react"
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useRouter } from "next/navigation"
import { toast } from "react-toastify"
import { Search, MapPin, UserCircle, X, ShoppingCart, ChevronDown } from "lucide-react" // Added ShoppingCart
import { useDispatch, useSelector } from "react-redux"
import Image from "next/image"
import { clearAuth } from "../config/redux/slices/authAndAddressSlice"
import { getTotalItems } from "../config/redux/slices/cartSlice"
import { useAuth } from "../context/authContext"
import { useGeolocation } from "../hooks/useGeoLoaction"
import dynamic from 'next/dynamic'
// Dynamic imports
const LoginModal = dynamic(() => import('./LoginModal'), {
  ssr: false,
  loading: () => null
})

const BottomNavigationBar = dynamic(() => import('./BottomNavigationBar'), {
  ssr: false,
  loading: () => null
})

const SEARCH_PLACEHOLDERS = [
  "'Maid in 15 Minutes'",
  "'Book a Home Maid'",
  "'Instant Cleaning Help'",
  "'Daily Maid Service'",

  "'Full-time Maid at Home'",
  "'Kitchen Cleaning Maid'",
  "'Bathroom Cleaning Help'",
  "'Quick Dusting & Mopping'",
  "'Housekeeping in 15 Minutes'"
]


const COLORS = {
  kWhite: "#FFFFFF",
  inputBorder: "#E0E0E0",
  inputBackground: "#F0F0F0",
  primaryFontColor: "#333333",
  secondaryFontColor: "#666666",
  primaryColor: "#00489b",
  kBlack: "#000000",
}

const HeaderContent = () => {
  const headerRef = useRef(null)
  const popupRef = useRef(null)
  const router = useRouter()
  const { logout, login } = useAuth()
  const dispatch = useDispatch()
  const { token } = useSelector((state) => state.auth)
  const Userprofile = useSelector((state) => state.auth.Userprofile);

  // Get location from Redux store
  const locationState = useSelector((state) => state.location);

  // Combine addressLine1 and addressLine2 for display
  const displayAddress = () => {
    const { addressLine1, addressLine2, city } = locationState;

    if (addressLine1 || addressLine2) {
      return `${addressLine1}, ${addressLine2}`;
    } else if (city) {
      return city;
    }
    return selectedLocation; // fallback
  };


  // Truncated address for mobile display (show only first few characters)
  const displayMobileAddress = () => {
    const fullAddress = displayAddress();
    const maxLength = 15; // Maximum characters to show on mobile

    if (fullAddress.length > maxLength) {
      return fullAddress.substring(0, maxLength) + "...";
    }
    return fullAddress;
  };

  // State
  const [placeholder, setPlaceholder] = useState("")
  const [placeholderIndex, setPlaceholderIndex] = useState(0)
  const [subIndex, setSubIndex] = useState(0)


  const [reverse, setReverse] = useState(false)
  const [showProfilePopup, setShowProfilePopup] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [hasMounted, setHasMounted] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [isClient, setIsClient] = useState(false)
  const totalItems = useSelector(getTotalItems)
  const menuRef = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Typewriter effect




  // Handle outside click for profile popup
  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowProfilePopup(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const { selectedLocation, isFetchingLocation } = useGeolocation()


  const Logout = () => {
    logout()
    toast.success("Logout Successfully")
    dispatch(clearAuth())
  }

  useEffect(() => {
    setHasMounted(true)
    setIsClient(true)
  }, [])

  // Memoized handleLocationSelect




  return (
    <>
      <LoginModal show={showLoginModal} onClose={() => setShowLoginModal(false)} />
      <nav
        ref={headerRef}
        className="fixed top-0 w-full h-[50px] md:h-[75px] z-30"
        style={{ background: COLORS.kWhite, borderBottom: `1px solid ${COLORS.inputBorder}` }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
          <div
            className="
        flex items-center justify-between h-full w-full
        gap-2 md:gap-4 min-w-0
      "
          >
            {/* Left: Logo (desktop) or Location (mobile) */}
            <div className="flex-shrink-0 flex items-center w-auto min-w-0">
              {/* Logo for Desktop */}
              <div className="hidden md:flex flex-col items-start cursor-pointer mt-2" onClick={() => router.push("/")}>
                <Image
                  src="/images/sortkaro_login_logo.png"
                  width={170}
                  height={200}
                  alt="SortKaro"
                  style={{ width: 'auto', height: 'auto' }}
                />
              </div>
              {/* Mobile Location Display */}
              <div
                className="flex md:hidden items-center gap-1 ml-1"
                onClick={() => router.push("/my-addresses")}
              >
                <span className="text-base font-bold truncate max-w-[150px]" style={{ color: COLORS.primaryFontColor }}>
                  {isFetchingLocation ? "Fetching..." : displayMobileAddress()}
                </span>
                <ChevronDown className="h-4 w-4 ml-1" style={{ color: COLORS.primaryColor }} />
              </div>
            </div>


            {/* Desktop Search & Location (hidden on mobile) */}


            {/* RIGHT: Cart and Profile - always visible and never wrapped/cut off */}
            <div className="flex items-center gap-3 md:gap-4 flex-shrink-0 ml-2">

              <div className="hidden md:flex items-center justify-center gap-8 flex-1 min-w-0">

                {/* Location Selector */}
                <button
                  onClick={() => router.push("/my-addresses")}
                  className="hidden lg:flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 hover:shadow-sm"
                  style={{
                    background: COLORS.inputBackground,
                    border: `1px solid ${COLORS.inputBorder}`,
                  }}
                >
                  <MapPin className="h-4 w-4" style={{ color: COLORS.primaryColor }} />
                  <span className="text-sm font-medium max-w-[250px] truncate" style={{ color: COLORS.primaryFontColor }}>
                    {isFetchingLocation ? "Fetching..." : displayMobileAddress()}
                  </span>
                  <ChevronDown className="h-4 w-4" style={{ color: COLORS.secondaryFontColor }} />
                </button>
              </div>
              <div className="relative inline-block" ref={menuRef}>
                {/* Trigger Button */}
                <button
                  className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                  style={{ color: COLORS.primaryColor }}
                  onClick={() => {
                    if (typeof window !== "undefined" && window.innerWidth < 768) {
                      router.push("/profile");
                      return;
                    }
                    setOpen((prev) => !prev);
                  }}
                >
                  <UserCircle className="h-6 w-6" />
                </button>

                {/* Dropdown Menu */}
                {open && (
                  <div className="absolute right-0 top-full mt-2 w-48  bg-white border border-gray-200 rounded-md shadow-md z-50">
                    {token && Userprofile?.name && (
                      <div
                        className="px-4 py-2 font-semibold text-gray-700 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          router.push("/profile");
                          setOpen(false);
                        }}
                      >
                        {Userprofile.name}
                      </div>
                    )}

                    <div
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                      onClick={() => {
                        router.push("/booking");
                        setOpen(false);
                      }}
                    >
                      My Booking
                    </div>

                    {token ? (
                      <div
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 font-medium"
                        onClick={() => {
                          Logout();
                          setOpen(false);
                        }}
                      >
                        Logout
                      </div>
                    ) : (
                      <div
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700 font-medium"
                        onClick={() => {
                          setShowLoginModal(true);
                          setOpen(false);
                        }}
                      >
                        Login
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>



      <BottomNavigationBar />
    </>
  )
}

// Client-side only wrapper to prevent hydration issues
const Header = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <nav className="fixed top-0 w-full h-[84px] bg-white shadow-sm z-40 border-b border-[#e3e3e3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
          <div className="flex justify-between items-center h-full">
            <div className="flex-shrink-0 flex items-center">
              <Image
                src="/placeholder.svg?height=32&width=120"
                alt="SortKaro"
                width={120}
                height={32}
                className="h-8 sm:h-10 w-auto"
              />
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
              <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
  return <HeaderContent />
}

export default Header
